"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImageSizes = exports.getImageParamsAndSizes = exports.getImageParams = void 0;
var _mui = require("@ori-ui/mui");
const {
  sm
} = _mui.theme.breakpoints.values;
const getImageSizes = ({
  mobileWidth = sm,
  desktopWidth
}) => mobileWidth === desktopWidth ? `${mobileWidth}px` : `(max-width: ${sm - 1}px) ${mobileWidth}px, ${desktopWidth}px`;
exports.getImageSizes = getImageSizes;
const getImageParams = ({
  mobileWidth = sm,
  desktopWidth
}) => mobileWidth === desktopWidth ? [{
  width: mobileWidth,
  quality: 90
}] : [{
  width: desktopWidth,
  quality: 85
}, {
  width: mobileWidth,
  quality: 90
}];
exports.getImageParams = getImageParams;
const getImageParamsAndSizes = params => {
  const imageParams = getImageParams(params);
  const sizes = getImageSizes(params);
  return {
    params: imageParams,
    sizes
  };
};
exports.getImageParamsAndSizes = getImageParamsAndSizes;
